import React from 'react';
import { Link } from 'react-router-dom';
import SortableHeader from '../../components/SortableHeader';
import { fmtCurrency } from '../../utils/formatCurrency';

function getOrderStatusColor(status) {
  switch (status) {
    case 'Order Created': return 'warning';
    case 'Shipped': return 'success';
    default: return 'gray';
  }
}

function AccountOrdersTab({
  accountId,
  sortedOrders,
  ordersSort,
  handleOrdersSort,
}) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Orders</h3>
      </div>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <SortableHeader label="Order #" field="order_number" sortField={ordersSort.field} sortDirection={ordersSort.direction} onSort={handleOrdersSort} />
              <SortableHeader label="Total" field="total" sortField={ordersSort.field} sortDirection={ordersSort.direction} onSort={handleOrdersSort} />
              <SortableHeader label="Status" field="status" sortField={ordersSort.field} sortDirection={ordersSort.direction} onSort={handleOrdersSort} />
              <SortableHeader label="Order Date" field="order_date" sortField={ordersSort.field} sortDirection={ordersSort.direction} onSort={handleOrdersSort} />
            </tr>
          </thead>
          <tbody>
            {sortedOrders.length > 0 ? (
              sortedOrders.map(order => (
                <tr key={order.id}>
                  <td>
                    <Link to={`/orders/${order.id}`} state={{ fromAccount: accountId }}>{order.order_number}</Link>
                  </td>
                  <td>${fmtCurrency(order.total)}</td>
                  <td>
                    <span className={`badge badge-${getOrderStatusColor(order.status)}`}>
                      {order.status}
                    </span>
                  </td>
                  <td>{new Date(order.order_date).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-secondary">No orders</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AccountOrdersTab;
